import ReelContainer from "./container";

export default ReelContainer;